(function(){
    'use strict'

    angular
    .module('app.cuentasContables')
    .controller('CuentasContables', CuentasContables);

    CuentasContables.$inject = ['$animationsSrv', 'CuentasContablesService', 'logger', '$location', 'UserInfoService'];

    function CuentasContables($animationsSrv, CuentasContablesService, logger, $location, UserInfoService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.cuentasContables = [];
        vm.title = 'Centros Costo';

        vm.goToEdit = function(cuentaContable){
            
            var path = '/editar-cuenta-contable/';

            if(cuentaContable){
                $location.path(path + cuentaContable.id);
            }
            else{
                $location.path(path);
            }
            
        };

        vm.openModal = function(modalName){
            $(modalName).modal('toggle');    
        };

        getAll();

        function getAll(){

            var promise = CuentasContablesService.getAll(UserInfoService.getCompaniaId());

            promise
            .then(function(cuentasContables){
                vm.cuentasContables = cuentasContables;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener las cuentas contables.');
                        break;
                }
            });
        };

        vm.delete = function(cuentaContable){
            var promise = CuentasContablesService.remove(cuentaContable);
            
            promise
            .then(function(response){
                vm.cuentasContables = vm.cuentasContables.filter(function(g) {
                    return g.id !== cuentaContable.id;
                });
                logger.success('Cuenta Contable eliminada con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al eliminar la Cuenta Contable');
                        break;
                }
                
            });   
        };

    }
})();